<template>
  <rmp-base-modal
    v-model="isOpen"
    extra-classes="BorderedHeaderModal"
  >
    <template #modal-header>
      <h2 class="u-text-center">
        Export Records
      </h2>
    </template>
    <template #modal-body>
      <h3>Confirm export</h3>
      <p>The export will include all the records.</p>
      <p>Any filter or search parameter won't be considered to scope results.</p>
      <div v-if="formHasQuestionsWithFilesToDownload()">
        <hr>
        <p>There are records with files associated, so please define how you wish each download link to be:</p>

        <div class="FileUploadsDownloadSettings">
          <rmp-radio-button
            v-model="typeOfLinkForFileUploadDownloads"
            label="Private"
            name="file_upload_type_link"
            class-name="RadioButton"
            value="private"
            :hint="{
              type: 'info',
              hint: 'A RMP Connect login will be required to download a file.'
            }"
          />
        </div>
        <div class="FileUploadsDownloadSettings">
          <rmp-radio-button
            v-model="typeOfLinkForFileUploadDownloads"
            label="Public - Login is not required"
            name="file_upload_type_link"
            class-name="RadioButton"
            value="public"
            :hint="{
              type: 'info',
              hint: 'A RMP Connect login is not required to download a file, generates public links that expire in 7 days.'
            }"
          />
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div class="u-floatLeft">
        <button
          class="Button Button--grey"
          @click="isOpen = false"
        >
          Cancel
        </button>
      </div>
      <div class="u-floatRight">
        <button
          :class="[{'is-loading': ui.submitLoading}, 'Button Button--green']"
          @click="handleExportEventRecords"
        >
          Yes, Export
        </button>
      </div>
    </template>
  </rmp-base-modal>
</template>
<script>
import { mapActions } from 'vuex';
import RmpBaseModal from '@rmpenterprise/base-modal';
import RmpRadioButton from '@rmpenterprise/form-radio-button';
import ModalActionsMixin from './mixins/modal-actions-mixin';

export default {
  components: { RmpBaseModal, RmpRadioButton },
  mixins: [ModalActionsMixin],
  props: {
    eventId: {
      type: Number,
      required: true,
      default: null,
    },
    eventQuestions: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      ui: {
        submitLoading: false,
      },
      typeOfLinkForFileUploadDownloads: 'private',
    };
  },
  methods: {
    ...mapActions('events', ['getEvent', 'exportEventRecords']),
    formHasQuestionsWithFilesToDownload() {
      return this.eventQuestions.filter((question) => {
        return question.has_files === true;
      }).length > 0;
    },
    handleExportEventRecords() {
      this.ui.submitLoading = true;
      this.exportEventRecords({ eventId: this.eventId, typeOfLinkForFileUploadDownloads: this.typeOfLinkForFileUploadDownloads })
        .then(({ data }) => {
          this.ui.submitLoading = false;
          this.isOpen = false;
          this.$bus.$emit('displayMsg', {
            text: data.message,
            type: 'success',
          });
        })
        .catch(({ data }) => {
          this.isOpen = false;
          this.ui.submitLoading = false;
          this.$bus.$emit('displayMsg', {
            text: data.message,
            type: 'warning',
          });
        });
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .FileUploadsDownloadSettings {
  .Form-field--radio{
    width: 95%;
  }

  .Modal-body{
    padding-bottom: 15px;
  }

  .Hint{
    margin-top: 15px;
    margin-bottom: 15px;
  }
}
</style>
